import * as React from 'react';
import classNames from 'classnames';
import FlexeButton from '../../shared/FlexeButton';

enum SortDirection {
  Ascending = 'ascending',
  Descending = 'descending',
  None = 'none'
}

interface StopgapSortLinkDoNotUseProps {
  element: JSX.Element | string;
  testIdKey: number;
  sortable: boolean;
  sortDirection?: SortDirection;
  onSort?: (colIndex: number, sortDir: SortDirection) => void;
}

function StopgapSortLinkDoNotUse(props: StopgapSortLinkDoNotUseProps) {
  const sortClasses = [
    'fa',
    props.sortDirection === SortDirection.Ascending && 'fa-sort-asc',
    props.sortDirection === SortDirection.Descending && 'fa-sort-desc',
    props.sortDirection === SortDirection.None && 'fa-sort'
  ];

  const linkId = `${props.testIdKey}-${props.sortDirection}`;

  const renderButtonGuts = () => {
    return (
      <>
        <span>{props.element}</span>
        <i data-testid={`sort-icon-${props.testIdKey}`} className={classNames(sortClasses)} />
      </>
    );
  };

  const getSortDir = (input) => {
    if (input === SortDirection.Ascending) {
      return SortDirection.Ascending;
    } else if (input === SortDirection.Descending) {
      return SortDirection.Descending;
    } else {
      return SortDirection.None;
    }
  };

  const handleSortClick = (e: any) => {
    const sd = e.currentTarget.id.slice(2, e.currentTarget.id.length);
    props.onSort(parseInt(e.currentTarget.id.charAt(0), 10), getSortDir(sd));
  };

  return (
    <>
      {props.sortable ? (
        <FlexeButton
          data-testid={`sort-link-${props.testIdKey}`}
          level="collapsed"
          handleClick={handleSortClick}
          text={renderButtonGuts()}
          id={linkId}
        />
      ) : (
        <>
          <span>{props.element}</span>
        </>
      )}
    </>
  );
}

export default StopgapSortLinkDoNotUse;
